import React, { Component } from "react";
import { Icon } from "react-materialize";

import ConfigurationManager from "../../configuration/ConfigurationManager";

//import wbLogo from "./wb.svg";
// import wbLogo from "./White.png";
// import starlabsLogo from "./starlabs.svg";

import artAssetsImg from "./nav_artassets.png";
import auditImg from "./nav_audit.png";
import helpImg from "./nav_help.png";
import jobsImg from "./nav_jobs.png";
import searchImg from "./nav_search.png";
import submitJobImg from "./nav_submitjob.png";
import wbShieldImg from "./nav_wbshield.png";

import "./Header.css";

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSubmitJobMenu: false,
      showHelpMenu: false,
    };
  }

  get showSubmitJobMenu() {
    return this.state.showSubmitJobMenu;
  }

  set showSubmitJobMenu(showSubmitJobMenu) {
    this.setState({ showSubmitJobMenu: showSubmitJobMenu });
  }

  get showHelpMenu() {
    return this.state.showHelpMenu;
  }

  set showHelpMenu(showHelpMenu) {
    this.setState({ showHelpMenu: showHelpMenu });
  }

  render() {
    const hrefLink = "#";
    const { currentUser } = this.props;
    const { showSubmitJobMenu, showHelpMenu } = this.state;

    let visibleButtons = {
      submitJob: true,
      productJob: true,
      marketingJob: true,
      packagingJob: true,
      publishingJob: true,
      gteJob: true,
      jobsPage: true,
      assetSearch: true,
      legacySearch: true,
      helpMenu: true,
      licenseeHelp: true,
      publisherHelp: true,
      productionManagerHelp: true,
      baRepHelp: true,
      resetView: true,
    };

    let access = currentUser != null ? currentUser.properties.groups : [];

    if (
      (access.includes("rle:licensee") ||
        access.includes("rle:licenseeDesigner")) &&
      !access.includes("lob:publishing")
    ) {
      visibleButtons.assetSearch = false;
    }

    if (
      access.includes("rle:licensee") ||
      access.includes("rle:licenseeDesigner")
    ) {
      visibleButtons.assetSearch = true;
    }

    // restrict wbcp access
    var wbArray = [];
    for (var item in access) {
      if (
        typeof access[item] === "string" &&
        access[item].substr(0, 6) === "rle:wb" &&
        !access.includes("rle:licensee")
      ) {
        visibleButtons.submitJob = false;
        //this.$.jobsPage.style.marginLeft = "0px";
        wbArray.push(access[item]);
      }
    }
    if (!access.includes("rle:wbcpCreative")) {
      visibleButtons.resetView = false;
    }
    if (!access.includes("rle:wbcpLegacy")) {
      visibleButtons.legacySearch = false;
    }
    if (wbArray.length === 0) {
      // restrict licensee access based on line of business
      visibleButtons.baRepHelp = false;
      if (access.includes("rle:licensee")) {
        if (!access.includes("lob:gte")) {
          visibleButtons.gteJob = false;
        }
        if (!access.includes("lob:publishing")) {
          visibleButtons.publishingJob = false;
          //          this.$.searchDropdown.removeChild(this.$.bookSearch);
          visibleButtons.publisherHelp = false;
          visibleButtons.productionManagerHelp = false;
        }
        if (
          !access.includes("lob:fashionHome") &&
          !access.includes("lob:toys")
        ) {
          visibleButtons.productJob = false;
          visibleButtons.marketingJob = false;
          visibleButtons.packagingJob = false;
        }
        if (
          !visibleButtons.productJob &&
          !visibleButtons.marketingJob &&
          !visibleButtons.packagingJob &&
          !visibleButtons.publishingJob &&
          !visibleButtons.gteJob
        ) {
          visibleButtons.submitJob = false;
          //          this.$.jobsPage.style.marginLeft = "0px";
        }
      } else if (access.includes("rle:licenseeDesigner")) {
        visibleButtons.submitJob = false;
        visibleButtons.jobsPage = false;
        if (!access.includes("lob:publishing")) {
          visibleButtons.publisherHelp = false;
          visibleButtons.productionManagerHelp = false;
        }
      }
    }

    const wbcpHost = ConfigurationManager.getProperty("WBCP_HOST");
    const wbcpPort = ConfigurationManager.getProperty("WBCP_PORT");

    return (
      <header id="navbar" className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <a href="https://portal.starlabs.warnerbros.com" target="_self">
              <img src={wbShieldImg} alt="" />
              <h1>STAR LABS</h1>
            </a>
          </div>
          <ul className="nav-links">
            <li
              id="SubmitJob"
              hidden={!visibleButtons.submitJob}
              onMouseOver={() => (this.showSubmitJobMenu = true)}
              onMouseLeave={() => (this.showSubmitJobMenu = false)}
            >
              <a href={hrefLink} style={{ margin: "0", userSelect: "none" }}>
                <img src={submitJobImg} />
                <span>Submit Job</span>
              </a>
              <div
                hidden={!showSubmitJobMenu}
                id="SubmitJobMenu"
                className="submit-job-menu"
              >
                <a
                  id="productPage"
                  href={`${wbcpHost}:${wbcpPort}/submit/product/`}
                  style={!visibleButtons.productJob ? { display: "none" } : {}}
                >
                  Product
                </a>
                <a
                  id="packagingPage"
                  href={`${wbcpHost}:${wbcpPort}/submit/packaging/`}
                  style={
                    !visibleButtons.packagingJob ? { display: "none" } : {}
                  }
                >
                  Packaging
                </a>
                <a
                  id="marketingPage"
                  href={`${wbcpHost}:${wbcpPort}/submit/marketing/`}
                  style={
                    !visibleButtons.marketingJob ? { display: "none" } : {}
                  }
                >
                  Marketing
                </a>
                <a
                  id="publishingPage"
                  href={`${wbcpHost}:${wbcpPort}/submit/publishing/`}
                  style={
                    !visibleButtons.publishingJob ? { display: "none" } : {}
                  }
                >
                  Publishing Plan
                </a>
                <a
                  id="gtePage"
                  href={`${wbcpHost}:${wbcpPort}/submit/gte/`}
                  style={!visibleButtons.gteJob ? { display: "none" } : {}}
                >
                  Themed Entertainment
                </a>
              </div>
            </li>
            <li id="JobsPage">
              <a
                href={`${wbcpHost}:${wbcpPort}/#!/jobs`}
                hidden={!visibleButtons.jobsPage}
              >
                <img src={jobsImg} />
                <span>Jobs</span>
              </a>
            </li>
            <li hidden={!visibleButtons.assetSearch}>
              <a href={`${wbcpHost}:${wbcpPort}/#!/search`}>
                <img src={artAssetsImg} />
                <span>Art Assets</span>
              </a>
            </li>
            <li id="LegacySearch" hidden={!visibleButtons.legacySearch}>
              <a href={`${wbcpHost}:${wbcpPort}/LegacySearch/`}>
                <img src={searchImg} />
                <span>Legacy Search</span>
              </a>
            </li>
            <li id="AuditReport" hidden={!visibleButtons.legacySearch}>
              <a href={`${wbcpHost}:${wbcpPort}/AuditReport/`}>
                <img src={auditImg} />
                <span>Audit Report</span>
              </a>
            </li>
            <li
              id="HelpMenu"
              hidden={!visibleButtons.helpMenu}
              onMouseOver={() => (this.showHelpMenu = true)}
              onMouseLeave={() => (this.showHelpMenu = false)}
            >
              <img src={helpImg} alt="" />
              <div
                id="HelpDropMenu"
                className="help-menu"
                hidden={!showHelpMenu}
              >
                <a
                  id="licenseeHelp"
                  href={`${wbcpHost}:${wbcpPort}/#!/help/licensee`}
                  style={
                    !visibleButtons.licenseeHelp ? { display: "none" } : {}
                  }
                >
                  Licensee Help
                </a>
                <a
                  id="publisherHelp"
                  href={`${wbcpHost}:${wbcpPort}/#!/help/publisher`}
                  style={
                    !visibleButtons.publisherHelp ? { display: "none" } : {}
                  }
                >
                  Publisher Help
                </a>
                <a
                  id="productionManagerHelp"
                  href={`${wbcpHost}:${wbcpPort}/#!/help/productionmanager`}
                  style={
                    !visibleButtons.productionManagerHelp
                      ? { display: "none" }
                      : {}
                  }
                >
                  Production Manager Help
                </a>
                <a
                  id="barepHelp"
                  href={`${wbcpHost}:${wbcpPort}/#!/help/barep`}
                  style={!visibleButtons.baRepHelp ? { display: "none" } : {}}
                >
                  PD / BA Help
                </a>
                <a
                  id="starlabsSupport"
                  href="mailto:starlabs.support@warnerbros.com"
                >
                  Email Support
                </a>
                {/*<a id="resetView" on-tap="_resetView">Reset View</a>*/}
              </div>
            </li>
          </ul>
          <div className="burger">
            <div className="line1" />
            <div className="line2" />
            <div className="line3" />
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
